// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onlineIndicator-root-Xm6 {\n    --stroke: rgb(var(--venia-global-color-text));\n    grid-area: primary;\n}\n\n@media (min-width: 640px) {\n    .onlineIndicator-root-Xm6 {\n        grid-column: 3 / 4;\n    }\n}\n\n@media (min-width: 960px) {\n    .onlineIndicator-root-Xm6 {\n        grid-column: 2 / 3;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "onlineIndicator-root-Xm6 flex h-[3rem] items-center ml-18 w-[3rem] sm_justify-self-start sm_ml-10"
};
export default ___CSS_LOADER_EXPORT___;
